export default "__VITE_ASSET__CQaa1L7j__"